// Этот файл скрывает предупреждение ResizeObserver loop completed with undelivered notifications
(function () {
  const origError = window.console.error;
  window.console.error = function (...args) {
    if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed with undelivered notifications')) {
      return;
    }
    origError.apply(window.console, args);
  };
})();

// Также скрываем ошибку в UI (react-error-overlay)
window.addEventListener(
  'error',
  function (event) {
    if (event.message && event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
  },
  true,
);
